import request from '@/config/axios'

// ========== OTA 渠道 ==========
export interface OtaChannelVO {
  id?: string | number
  channelCode: string // MEITUAN/QUNAR/CTRIP/FLIGGY
  channelName: string
  apiUrl?: string
  appId?: string
  appSecret?: string
  syncStatus: number // 0未同步/1同步中/2已同步/3同步失败
  status: number
  createTime?: string
}

// 渠道分页查询
export const getChannelPage = (params: any) => {
  return request.get({ url: '/hotel/ota/page', params })
}

// 获取渠道详情
export const getChannel = (id: string | number) => {
  return request.get({ url: '/hotel/ota/get?id=' + id })
}

// 新增渠道
export const createChannel = (data: OtaChannelVO) => {
  return request.post({ url: '/hotel/ota/create', data })
}

// 修改渠道
export const updateChannel = (data: OtaChannelVO) => {
  return request.put({ url: '/hotel/ota/update', data })
}

// 删除渠道
export const deleteChannel = (id: string | number) => {
  return request.delete({ url: '/hotel/ota/delete?id=' + id })
}

// ========== OTA 房型映射 ==========
export interface OtaRoomMappingVO {
  id?: string | number
  shopId: string | number
  shopName?: string
  spuId: string | number
  spuName?: string
  otaChannelId: string | number
  otaChannelName?: string
  otaRoomTypeCode: string
  otaRoomTypeName: string
  otaRatePlanCode?: string
  status: number
}

// 房型映射分页查询
export const getRoomMappingPage = (params: any) => {
  return request.get({ url: '/hotel/ota/room-mapping/page', params })
}

export const getRoomMapping = (id: string | number) => {
  return request.get({ url: '/hotel/ota/room-mapping/get?id=' + id })
}

export const createRoomMapping = (data: OtaRoomMappingVO) => {
  return request.post({ url: '/hotel/ota/room-mapping/create', data })
}

export const updateRoomMapping = (data: OtaRoomMappingVO) => {
  return request.put({ url: '/hotel/ota/room-mapping/update', data })
}

export const deleteRoomMapping = (id: string | number) => {
  return request.delete({ url: '/hotel/ota/room-mapping/delete?id=' + id })
}

// 批量编辑房型映射
export const batchUpdateRoomMapping = (data: OtaRoomMappingVO[]) => {
  return request.post({ url: '/hotel/ota/room-mapping/batch-save', data })
}

// ========== OTA 价格策略 ==========
export interface OtaPriceStrategyVO {
  id?: string | number
  shopId: string | number
  shopName?: string
  spuId: string | number
  spuName?: string
  otaChannelId: string | number
  otaChannelName?: string
  adjustType: number // 0固定金额/1百分比
  adjustValue: number
  minPrice?: number
  maxPrice?: number
  status: number
}

// 价格策略分页查询
export const getPriceStrategyPage = (params: any) => {
  return request.get({ url: '/hotel/ota/price-strategy/page', params })
}

export const getPriceStrategy = (id: string | number) => {
  return request.get({ url: '/hotel/ota/price-strategy/get?id=' + id })
}

export const createPriceStrategy = (data: OtaPriceStrategyVO) => {
  return request.post({ url: '/hotel/ota/price-strategy/create', data })
}

export const updatePriceStrategy = (data: OtaPriceStrategyVO) => {
  return request.put({ url: '/hotel/ota/price-strategy/update', data })
}

export const deletePriceStrategy = (id: string | number) => {
  return request.delete({ url: '/hotel/ota/price-strategy/delete?id=' + id })
}

// 批量编辑价格策略
export const batchUpdatePriceStrategy = (data: OtaPriceStrategyVO[]) => {
  return request.post({ url: '/hotel/ota/price-strategy/batch-save', data })
}
